"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("../../shared/styles");
var _ColorIndicator = require("./ColorIndicator.styled");
var _jsxRuntime = require("react/jsx-runtime");
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ConnectedColorIndicator__Wrapper",
  componentId: "sc-vq313o-0"
})(["height:20px;width:20px;position:relative;"]);
var ColorIndicatorUpperLeft = (0, _styledComponents.default)(_ColorIndicator.ColorIndicatorStyled).withConfig({
  displayName: "ConnectedColorIndicator__ColorIndicatorUpperLeft",
  componentId: "sc-vq313o-1"
})(["position:absolute;width:10px;height:10px;left:calc(50% - 10px / 2 - 5px);top:calc(50% - 10px / 2 - 5px);"]);
var ColorIndicatorLowerRight = (0, _styledComponents.default)(_ColorIndicator.ColorIndicatorStyled).withConfig({
  displayName: "ConnectedColorIndicator__ColorIndicatorLowerRight",
  componentId: "sc-vq313o-2"
})(["position:absolute;width:10px;height:10px;left:calc(50% - 10px / 2 + 5px);top:calc(50% - 10px / 2 + 5px);"]);
var Rectangle = (0, _styledComponents.default)(_ColorIndicator.ColorIndicatorStyled).withConfig({
  displayName: "ConnectedColorIndicator__Rectangle",
  componentId: "sc-vq313o-3"
})(["position:absolute;width:6px;height:2px;left:calc(50% - 6px / 2);top:calc(50% - 2px / 2);transform:rotate(45deg);"]);
var ConnectedColorIndicator = function ConnectedColorIndicator(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ColorIndicatorUpperLeft, {
      color: color
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Rectangle, {
      color: color
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorIndicatorLowerRight, {
      color: color
    })]
  });
};
ConnectedColorIndicator.defaultProps = {
  color: _styles.colors.icon.brand
};
var _default = exports.default = ConnectedColorIndicator;